define(() => {
    "use strict";

    const EventNames = {
        QUICK_VIEW_SHOWN: "QuickViewShown"
    };

    return {
        EventNames
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/QuickViewConstants.js